import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { DeepBI } from "../../../integrations";

export default function AISummaryWidget({ story }) {
  const [showSummary, setShowSummary] = useState(false);
  const summaryRef = useRef(null);

  const handleShowSummary = () => {
    setShowSummary(true);
    DeepBI.pingPaywallEventTrigger(story, "AISummaryClicked");
    setTimeout(() => {
      summaryRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 200);
    document.body.style.overflow = "hidden"; // prevent scroll when modal open
  };

  useEffect(() => {
    DeepBI.pingPaywallEventTrigger(story, "AISummaryView");
  }, []);

  const handleClose = () => {
    setShowSummary(false);
    DeepBI.pingPaywallEventTrigger(story, "AISummaryClosed");
    document.body.style.overflow = "auto";
  };

  const summaryText = get(story, ["metadata", "summary"], "AI summary not available.");
  const [summarySection, keyPoints] = splitSummary(summaryText);

  return (
    <div className="ai-summary-container">
      <button className="ai-summary-btn" onClick={handleShowSummary} disabled={!get(story, ["metadata", "summary"])}>
        ✨ AI Summary
      </button>

      {showSummary && (
        <div className="ai-summary-overlay" onClick={handleClose}>
          <div
            ref={summaryRef}
            className="ai-summary-card"
            onClick={e => e.stopPropagation()} // prevent closing when clicking inside card
          >
            <button className="ai-summary-close" onClick={handleClose}>
              <span>×</span>
            </button>
            <div className="ai-short-summary">
              <div>✨</div>
              <div>
                {" "}
                இந்தச் சுருக்கமானது, உங்கள் நேரத்தைத் திறம்பட மிச்சப்படுத்த, செயற்கை நுண்ணறிவு (AI) உதவியுடன் பரிசோதனை
                முயற்சியாக உருவாக்கப்பட்டது.
              </div>
            </div>
            <div className="ai-summary-content">
              <h2 className="ai-summary-title">Summary</h2>
              <p className="ai-summary-text">{summarySection}</p>
              {keyPoints.length > 0 && (
                <div>
                  {/* <h3 className="ai-summary-subtitle">Key Points</h3> */}
                  <ul className="ai-summary-list">
                    {keyPoints.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function splitSummary(rawText) {
  if (!rawText) return ["", []];

  const clean = rawText.replace(/\r/g, "").trim();

  // Remove PUSH TITLE and PUSH DESCRIPTION blocks completely
  const noPush = clean
    .replace(/PUSH TITLE[\s\S]*?(?=PUSH DESCRIPTION|$)/i, "")
    .replace(/PUSH DESCRIPTION[\s\S]*$/i, "")
    .trim();

  // Extract SUMMARY section
  let summarySection = "";
  const summaryMatch = noPush.match(/SUMMARY\s*(.+?)(?=\nBULLETS|$)/is);
  if (summaryMatch) {
    summarySection = summaryMatch[1].trim();
  }

  // Extract BULLETS section
  let keyPoints = [];
  const bulletsMatch = noPush.match(/BULLETS\s*([\s\S]+)/i);
  if (bulletsMatch) {
    const bulletsText = bulletsMatch[1].trim();

    keyPoints = bulletsText
      // eslint-disable-next-line no-useless-escape
      .split(/\n|•|(?<=^)[\-–]\s+/m) // <-- FIXED HERE
      .map(p => p.trim())
      .filter(Boolean);
  }

  return [summarySection, keyPoints];
}

AISummaryWidget.propTypes = {
  story: PropTypes.shape()
};
